import React from 'react';

export const ErrorDisplay = ({ message }: { message: string | undefined }) => {
  return (
    <div className="d-flex justify-content-center align-items-center position-absolute">
      <span style={{ color: 'red' }}>Ошибка: {message}</span>
    </div>
  );
};
